import { ModalOptionsType } from '@/context/modal-context/types'
import { useWindowSize } from 'usehooks-ts'
import { useModal } from './use-modal'

/**
 * this is just a wrapper for the useModal hook
 * that opens the sign-up modal with a specific position
 * if the screen width is greater than 768
 */

export function useSignUpModal() {
  const modal = useModal()
  const { width = 0 } = useWindowSize()

  if (width > 768) {
    return {
      open: (options?: ModalOptionsType) =>
        modal.open('sign-up', { position: 'right', ...options }),
      close: () => modal.close(),
    }
  }

  return {
    open: (options?: ModalOptionsType) =>
      modal.open('sign-up', { position: 'bottom', ...options }),
    close: () => modal.close(),
  }
}
